import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Flex, Label, Input, Select, FormGroup } from './ui';
import { theme } from '../styles/theme';

const HEADER_FORMATS = [
  { value: '',         labelKey: 'headerFormats.none',     labelDefault: '— Sem header —' },
  { value: 'TEXT',     labelKey: 'headerFormats.text',     labelDefault: 'Texto' },
  { value: 'IMAGE',    labelKey: 'headerFormats.image',    labelDefault: 'Imagem' },
  { value: 'VIDEO',    labelKey: 'headerFormats.video',    labelDefault: 'Vídeo' },
  { value: 'DOCUMENT', labelKey: 'headerFormats.document', labelDefault: 'Documento' },
];

export default function TemplateHeaderFooter({ header, footer, limitedTimeOffer, onChange }) {
  const { t } = useTranslation('mktpl');

  const setHeader = (field, value) =>
    onChange({ header: { ...(header || {}), [field]: value }, footer, limitedTimeOffer });

  const clearHeader = () =>
    onChange({ header: null, footer, limitedTimeOffer });

  const setFooter = (value) =>
    onChange({ header, footer: value ? { text: value } : null, limitedTimeOffer });

  const setLTO = (field, value) =>
    onChange({ header, footer, limitedTimeOffer: { ...(limitedTimeOffer || {}), [field]: value } });

  const toggleLTO = (enabled) =>
    onChange({ header, footer, limitedTimeOffer: enabled ? { text: 'Oferta por tempo limitado!', hasExpiration: true } : null });

  const headerFormat = header?.format || '';

  return (
    <Section>
      <SectionLabel>{t('headerSection')}</SectionLabel>

      <Flex gap={theme.spacing[3]}>
        <FormGroup style={{ flex: 1 }}>
          <Label>{t('headerFormat')}</Label>
          <Select value={headerFormat} onChange={e => {
            if (!e.target.value) clearHeader();
            else setHeader('format', e.target.value);
          }}>
            {HEADER_FORMATS.map(o => <option key={o.value} value={o.value}>{t(o.labelKey, { defaultValue: o.labelDefault })}</option>)}
          </Select>
        </FormGroup>

        {headerFormat === 'TEXT' && (
          <FormGroup style={{ flex: 2 }}>
            <Label>{t('headerText')}</Label>
            <Input value={header?.text || ''} onChange={e => setHeader('text', e.target.value)} placeholder={t('headerTextPlaceholder')} />
          </FormGroup>
        )}

        {['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerFormat) && (
          <FormGroup style={{ flex: 2 }}>
            <Label>{t('headerHandle')}</Label>
            <Input value={header?.headerHandle || ''} onChange={e => setHeader('headerHandle', e.target.value)} placeholder="4::aW..." />
            <Helper>{t('headerHandleHint')}</Helper>
          </FormGroup>
        )}
      </Flex>

      <FormGroup>
        <Label>{t('footerText')}</Label>
        <Input value={footer?.text || ''} onChange={e => setFooter(e.target.value)} placeholder={t('footerPlaceholder')} maxLength={60} />
        <Helper>{t('footerHint')}</Helper>
      </FormGroup>

      <LTORow>
        <input type="checkbox" id="lto-toggle" checked={!!limitedTimeOffer} onChange={e => toggleLTO(e.target.checked)} />
        <label htmlFor="lto-toggle" style={{ fontSize: theme.typography.sm, cursor: 'pointer' }}>
          {t('limitedTimeOffer')}
        </label>
      </LTORow>

      {limitedTimeOffer && (
        <Flex gap={theme.spacing[3]} style={{ marginTop: theme.spacing[2] }}>
          <FormGroup style={{ flex: 2 }}>
            <Label>{t('ltoText')}</Label>
            <Input value={limitedTimeOffer.text || ''} onChange={e => setLTO('text', e.target.value)} placeholder="Oferta por tempo limitado!" />
          </FormGroup>
          <FormGroup style={{ flex: 1, justifyContent: 'flex-end' }}>
            <LTORow>
              <input type="checkbox" id="lto-exp" checked={limitedTimeOffer.hasExpiration !== false} onChange={e => setLTO('hasExpiration', e.target.checked)} />
              <label htmlFor="lto-exp" style={{ fontSize: theme.typography.sm, cursor: 'pointer' }}>{t('ltoHasExpiration')}</label>
            </LTORow>
          </FormGroup>
        </Flex>
      )}
    </Section>
  );
}

const Section      = styled.div`margin-top: ${theme.spacing[3]}; padding-top: ${theme.spacing[3]}; border-top: 1px solid ${theme.colors.border};`;
const SectionLabel = styled.div`font-size: ${theme.typography.xs}; font-weight: ${theme.typography.semibold}; color: ${theme.colors.textSecondary}; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: ${theme.spacing[2]};`;
const Helper       = styled.div`font-size: ${theme.typography.xs}; color: ${theme.colors.textMuted}; margin-top: ${theme.spacing[1]};`;
const LTORow       = styled.div`display: flex; align-items: center; gap: ${theme.spacing[2]}; margin-top: ${theme.spacing[1]};`;
